export const LABELS = {
  coreBasic: "CORE基礎編",
  coreActiveLearning: "CORE実践編",
  base: "BASE",
};

/** CORE2.3(mitsuwa_id:142~)から機能が大幅に変わるため、2.3より前の教材をoldとする */
export const OLD_MATERIAL_THRESHOLD = 141;

export const TEACHING_MATERIAL_KEYWORDS = {
  ORIENTATION: "オリエンテーション",
  MIDDLE: "中学",
  HIGH: "高校",
  CORE: "core",
  BASE: "base",
} as const;
